export default "__VITE_ASSET__DKC8_XpN__"